/**
 * @module-isolated analytics-lab
 * Tabla de definiciones GI vs LeadTrack — transparencia de por qué los números difieren.
 */
import { PageHeader, SectionHeader } from '../../../shared/components/index.js';
import LabBanner from '../components/LabBanner.jsx';
import { DEFINITION_ROWS } from '../data/definition-rows.js';

export default function LabDefinicionesPage() {
  return (
    <div className="analytics-module lab-module">
      <LabBanner pageLabel="Comparar definiciones" />
      <PageHeader
        eyebrow="Lab · evaluar UX LeadTrack"
        title="Comparar definiciones"
        subtitle="Si ves números distintos entre Analytics GI y LeadTrack, casi siempre es definición o universo distinto — no necesariamente un bug."
      />

      <section className="analytics-section">
        <SectionHeader
          title="¿Miden lo mismo?"
          note="Referencia auditoría LeadTrack 2026-08-06 · workspace GiCapital."
        />
        <div className="analytics-panel lab-def-wrap">
          <table className="lab-def-table">
            <thead>
              <tr>
                <th>Métrica</th>
                <th>GI Analytics (oficial)</th>
                <th>LeadTrack</th>
                <th>¿Igual?</th>
                <th>Nota</th>
              </tr>
            </thead>
            <tbody>
              {DEFINITION_ROWS.map((row) => (
                <tr key={row.metric}>
                  <td>
                    <strong>{row.metric}</strong>
                  </td>
                  <td>{row.gi}</td>
                  <td>{row.leadtrack}</td>
                  <td>
                    <span className={'lab-chip is-' + (row.same ? 'ok' : 'gap')}>
                      {row.same ? 'Sí' : 'No'}
                    </span>
                  </td>
                  <td className="lab-muted">{row.note}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      <section className="analytics-section">
        <SectionHeader title="Cómo usar esto" />
        <div className="analytics-panel">
          <ol className="lab-howto">
            <li>
              Tomá un KPI en LeadTrack y buscalo en esta tabla antes de comparar contra Resumen /
              Leads / Marketing.
            </li>
            <li>
              Si la columna “¿Igual?” es No, no esperes el mismo número — son productos con
              universos distintos.
            </li>
            <li>
              La referencia de negocio GI sigue siendo el menú <strong>Oficial</strong>, no el
              Lab ni LeadTrack.
            </li>
          </ol>
        </div>
      </section>
    </div>
  );
}
